import React from "react";

import NestedMenu from "components/Shared/NestedMenu";

import { useAuth } from "hooks/useAuth";

const ClientSidebar = () => {
  const { loggedInUser } = useAuth();

  const studentMenuOptions = [
    {
      title: "Dashboard",
      path: "/app/client/dashboard",
      icon: "DashboardCustomize",
    },
    {
      title: "Info",
      icon: "PersonPinOutlined",
      subMenus: [
        {
          title: "Profile",
          path: "/app/client/profile/basic",
          icon: "AccountBoxOutlined",
        },
        {
          title: "Educations",
          path: "/app/client/profile/education",
          icon: "SchoolOutlined",
        },
        {
          title: "Employments",
          path: "/app/client/profile/employment",
          icon: "WorkOutlineOutlined",
        },
        {
          title: "Tests",
          path: "/app/client/profile/test",
          icon: "AssignmentOutlined",
        },
      ],
    },
    {
      title: "Course",
      icon: "MenuBookOutlined",
      subMenus: [
        {
          title: "Favorite Courses",
          path: "/app/client/course/favorite",
          icon: "BookmarksOutlined",
        },
        {
          title: "Study Options",
          path: "/app/client/course/study-options",
          icon: "LibraryBooksOutlined",
        },
        {
          title: "Search",
          path: `/app/course/search?ref=${loggedInUser?.typeRef}&type=Client`,
          icon: "Search",
        },
      ],
    },
    {
      title: "Updates",
      path: "/app/client/note",
      icon: "CachedOutlined",
    },
    {
      title: "Documents",
      path: "/app/client/document",
      icon: "ArticleOutlined",
    },
    {
      title: "Forms",
      path: "/app/client/form",
      icon: "FormatAlignLeftOutlined",
    },
    {
      title: "Transactions",
      path: "/app/client/transaction",
      icon: "ReceiptLongOutlined",
    },
    {
      title: "Applications",
      path: "/app/client/application",
      icon: "HistoryEduOutlined",
    },
    {
      title: "Notifications",
      path: "/app/client/notification",
      icon: "NotificationsOutlined",
    },
    {
      title: "Tickets",
      path: "/app/client/ticket",
      icon: "ConfirmationNumberOutlined",
    },
  ];

  return <NestedMenu menu={studentMenuOptions} initiallyOpenedMenu="Course" />;
};

export default ClientSidebar;
